const defaultState = {
  sessionId: false,
  firstName: false,
  lastName: false,
  emailAddress: false,
}

const agentFlow = (
  state = defaultState,
  action
) => {
  switch (action.type) {
    case 'SET_CRYPTO_ESCROW_FLOW_SESSION_ID': {
      let stateCopy = JSON.parse(JSON.stringify(state));
      stateCopy.sessionId = action.sessionId;
      return stateCopy;
    }
    case 'SET_CRYPTO_ESCROW_FLOW_BASIC_INFO': {
      let {
        firstName,
        lastName,
        emailAddress,
      } = action;
      let stateCopy = JSON.parse(JSON.stringify(state));
      stateCopy.firstName = firstName;
      stateCopy.lastName = lastName;
      stateCopy.emailAddress = emailAddress;
      return stateCopy;
    }
    case 'SET_CRYPTO_ESCROW_FLOW_FIRST_NAME': {
      let {
        firstName,
      } = action;
      let stateCopy = JSON.parse(JSON.stringify(state));
      stateCopy.firstName = firstName;
      return stateCopy;
    }
    case 'SET_CRYPTO_ESCROW_FLOW_LAST_NAME': {
      let {
        lastName,
      } = action;
      let stateCopy = JSON.parse(JSON.stringify(state));
      stateCopy.lastName = lastName;
      return stateCopy;
    }
    case 'SET_CRYPTO_ESCROW_FLOW_EMAIL_ADDRESS': {
      let {
        emailAddress,
      } = action;
      let stateCopy = JSON.parse(JSON.stringify(state));
      stateCopy.emailAddress = emailAddress;
      return stateCopy;
    }
    case 'SET_CRYPTO_ESCROW_FLOW_LOCATION': {
      let {
        location,
      } = action;
      let stateCopy = JSON.parse(JSON.stringify(state));
      stateCopy.location = location;
      return stateCopy;
    }
    case 'SET_CRYPTO_ESCROW_FLOW_CONTACT_TYPE': {
      let {
        contactType,
      } = action;
      let stateCopy = JSON.parse(JSON.stringify(state));
      stateCopy.contactType = contactType;
      return stateCopy;
    }
    case 'RESET_CRYPTO_ESCROW_FLOW': {
      let stateCopy = JSON.parse(JSON.stringify(defaultState));
      return stateCopy;
    }
    default:
      return state
  }
}

export default agentFlow;